<template>
  <div class="flex flex-col">
    <label
      class="inline-flex items-center"
      :class="[
        { 'flex-row-reverse': align === 'left'}
      ]"
    >
      <span
        v-if="value instanceof Array"
        class="flex-grow inline-block"
        :class="[
          { 'ml-4': align === 'left'},
          { 'mr-4 text-right': align === 'right'}
        ]"
      >
       <slot name="input">Need Input</slot>
      </span>
      <span
        v-else
        class="flex-grow"
        :class="[
          { 'ml-4': align === 'left'},
          { 'mr-4 text-right': align === 'right'}
        ]"
      >{{  label || displayValue }}</span>
      <input
        type="checkbox"
        class="form-checkbox w-6 h-6 border-gray-600"
        :class="[
          { 'bg-gray-200': disabled},
        ]"
        :checked="checked"
        :value="displayValue"
        @change="updateInput"
        :disabled="disabled"
        :data-test="`option-${slugValue}`"
      />
    </label>
    <slot :checked="checked"></slot>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MCheckboxItem',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: [Array, String, Boolean],
      default: false,
    },
    align: {
      type: String,
      default: 'left',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Array],
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (Array.isArray(this.value)) {
        return this.value.map((input) => {
          if (Object.prototype.hasOwnProperty.call(input, 'input')) {
            return `${input.value} ${input.input} `;
          }
          return `${input.value}`;
        }).join('');
      }
      return this.value;
    },
    slugValue() {
      return _.kebabCase(this.displayValue);
    },
  },
  methods: {
    updateInput(event) {
      const isChecked = event.target.checked;

      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue];

        if (isChecked) {
          newValue.push(event.target.value);
        } else {
          newValue.splice(newValue.indexOf(event.target.value), 1);
        }
        this.$emit('change', newValue);
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue);
      }
    },
  },
};
</script>

<style>

</style>
